module.exports = __webpack_public_path__ + "img/v2power_logo.faf3b75d.svg";